<template>
  <div
    id="stick-column"
    class="m-stick-column"
    :style="{ top: sticky.top + 'px' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VStickyColumn',
  introduction: 'Container which sticks the top/bottom of the content to the top/bottom of the parent based on the scroll direction.',
  props: {
    relativeElementSelector: {
      type: String,
      required: true,
      note: 'Unused needs removal.',
    },
    pageClass: {
      type: String,
      required: true,
      note: 'The CSS class of the page it is on.',
    },
  },
  data() {
    return {
      columnHeight: null,
      scrollElement: null,
      scrollTop: 0,
      sticky: {
        top: 0,
      },
      scroll: {
        last: null,
        direction: null,
        menuPoint: 0,
        menuFixed: false,
      },
    };
  },
  mounted() {
    this.scrollElement = document.querySelector(`${this.pageClass}.router`);
    if (this.scrollElement) {
      this.scrollElement.addEventListener('scroll', this.onScroll);
    }
  },
  beforeDestroy() {
    if (this.scrollElement) {
      this.scrollElement.removeEventListener('scroll', this.onScroll);
    }
  },
  computed: {
    relativeColumn() {
      return document.querySelector(this.relativeElementSelector);
    },
  },
  methods: {
    onScroll() {
      const col = document.getElementById('stick-column');
      const router = document.getElementById('o-router');
      const offset = router.clientHeight - col.clientHeight - 30;
      if (router.clientHeight > col.clientHeight) { // Router scroll zone taller than sticky column
        this.sticky.top = 0;
      } else if (this.scroll.last && router.scrollTop > this.scroll.last) { // Scroll down
        this.sticky.top = offset;
      } else if (this.scroll.last && router.scrollTop < this.scroll.last) { // Scroll up
        this.sticky.top = 0;
      }

      this.scroll.last = router.scrollTop;
    },
  },
};
</script>

<style scoped>
.m-stick-column {
  position: sticky !important;
  top: 0;
  transition: top 0.2s ease;
}

@media (max-width: 450px) {
  .m-stick-column {
    margin-bottom: 35px;
  }
}
</style>
